import { render, staticRenderFns } from "./textBuilder.vue?vue&type=template&id=65352c86"
import script from "./textBuilder.vue?vue&type=script&lang=js"
export * from "./textBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports